<template>
    <div>
      <h2>Shipping Locations</h2>
      <p>Content for Shipping Locations</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ShippingLocations'
  };
  </script>